import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Row,
    Col,
    Label,
    Input,
    FormFeedback,
    Button
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const SemesterModal = ({ isOpen, toggle, isEdit, semester, onSubmit }) => {
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: (semester && semester.id) || '',
            uuid: (semester && semester.uuid) || '',
            name: (semester && semester.name) || '',
            code: (semester && semester.code) || '',
            is_active: (semester && semester.is_active) || '1', // Valeur par défaut
        },
        validationSchema: Yup.object({
            // Correction de tes validations qui attendaient des types "number" par erreur
            name: Yup.string().required("Veuillez saisir le nom du semestre"),
            code: Yup.string().required("Veuillez saisir le code du semestre"),
        }),
        onSubmit: (values) => {
            onSubmit(values);
            validation.resetForm();
        },
    });

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" id="staticBackdrop">
            <ModalHeader toggle={toggle} tag="h4">
                {isEdit ? "Modifier - Semestre" : "Ajouter - Semestre"}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                    <Row>
                        <Col className="col-12">
                            <div className="mb-3">
                                <Label>Nom</Label>
                                <Input
                                    name="name"
                                    type="text"
                                    placeholder="Ex: Semestre 1"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.name}
                                    invalid={validation.touched.name && validation.errors.name}
                                />
                                {validation.touched.name && validation.errors.name && (
                                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                )}
                            </div>

                            <div className="mb-3">
                                <Label>Code</Label>
                                <Input
                                    name="code"
                                    type="text"
                                    placeholder="Ex: S1"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.code}
                                    invalid={validation.touched.code && validation.errors.code}
                                />
                                {validation.touched.code && validation.errors.code && (
                                    <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="text-end">
                                <Button color="primary" type="submit">
                                    {isEdit ? "Modifier" : "Enregistrer"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default SemesterModal;